import createAPIRequest from '../helpers/createAPIRequest'
import getRaceDetails from '../helpers/getRaceDetails'
import getPlayerId from '../helpers/getPlayerId'
import isEmpty from '../helpers/isEmpty'
import store from '../store/index'

function normaliseCombatantFatigue(fatigue) {
  if (typeof fatigue !== 'string') {
    return fatigue
  }

  return fatigue.trim().toLowerCase()
}
//---------------
// edit combatant
//---------------
export default async function useEditCombatant(this_combatant, copy_image = false) {
  // console.log("--------------------");
  // console.log("IN useEditCombatant");

  return new Promise((resolve) => {
    //===========================================
    // A. prep
    //===========================================
    //--------------
    // access store
    //--------------
    const this_store = store
    const this_store_state = store.state.combat
    //--------------------
    // set api call parms
    //--------------------
    let slug = ''
    let parm_slug = ''
    let copy_image_url = ''

    if (this_combatant.slug != '') {
      parm_slug = this_combatant.slug
    }

    let request_parms = {
      endpoint: 'api/v1/combatants/',
      slug: parm_slug,
    }
    //--------------------
    // create api request
    //--------------------
    let request = createAPIRequest(request_parms)
    //------------------------------------
    // remove image pending separate call
    //------------------------------------
    if (copy_image) {
      copy_image_url = this_combatant.image
    }
    delete this_combatant.image
    //-----------------
    // insert arena.id (new)
    //-----------------
    if (!this_combatant.arena) {
      this_combatant.arena = this_store_state.arena.id
    }
    //-----------------------------
    // normalise combatant fatigue
    //-----------------------------
    if (Object.hasOwn(this_combatant, 'fatigue')) {
      this_combatant.fatigue = normaliseCombatantFatigue(this_combatant.fatigue)
    }
    //-----------------------
    // where player selected
    //-----------------------
    if (this_combatant.player) {
      //-------------------------------
      // replace player string with id
      //-------------------------------
      let player_id = getPlayerId(
        this_combatant.player,
        this_store_state.arena.players,
        this_store.getters['combat/getCampaignPlayers'],
      )
      if (player_id) {
        this_combatant.player = player_id
      } else if (this_combatant.player_id) {
        this_combatant.player = this_combatant.player_id
      }
    }

    delete this_combatant.player_id
    //------------------------------------
    // replace race string with id + name
    //------------------------------------
    try {
      let race = getRaceDetails(this_combatant.race, this_store.getters['races/getRaces'])
      this_combatant.race = race.id
      this_combatant.race_name = race.name
    } catch {
      alert(window.bbUiErrorMsg('race not found for = ' + this_combatant.race))
    }
    //---------------
    // set api parms
    //---------------
    let api_parms_combatant = {
      api_request: request,
      payload: this_combatant,
    }
    //--------------------
    // set response parms
    //--------------------
    let response_parms = {
      combatant: null,
      image: null,
    }
    //===========================================
    // B. call combatant setup
    //===========================================
    this_store.dispatch('combat/editCombatant', api_parms_combatant).then((combatant) => {
      //-------------------
      // set response parm
      //-------------------
      response_parms.combatant = combatant.data
      //--------------------------
      // set slug for image update
      //--------------------------
      if (isEmpty(api_parms_combatant.payload.slug)) {
        slug = combatant.data.slug
      } else {
        slug = api_parms_combatant.payload.slug
      }
      //===========================================
      // C. set image file + call
      //===========================================
      let image_file = null
      let image_call = ''

      if (api_parms_combatant.payload.image_file == null) {
        image_file = copy_image_url
        image_call = 'combat/copyCombatantImage'
      } else {
        image_file = api_parms_combatant.payload.image_file
        image_call = 'combat/changeCombatantImage'
      }
      //--------------------------
      // setup image update parms
      //--------------------------
      if (image_file) {
        let api_parms_image = {
          slug: slug,
          image_file: image_file,
        }
        //-------------------------
        // call update image setup
        //-------------------------
        this_store.dispatch(image_call, api_parms_image).then((image) => {
          //-------------------
          // set response parm
          //-------------------
          response_parms.image = image.data
          resolve(response_parms)
        })
      } else {
        resolve(response_parms)
      }
    })
  })
}
